import * as net from 'util/Net';

import {ShareLinkMetadata} from '../ShareLinkConstants';

export function getOrCreateShareLinkMetadata(fileId: string): Promise<ShareLinkMetadata> {
  return net.postJSONPromise({
    url: `/1/api/files/${fileId}/share-link-metadata`,
  });
}

export function updateShareLinkMetadata(fileId: string, description: string): Promise<ShareLinkMetadata> {
  return net.patchJSONPromise({
    url: `/1/api/files/${fileId}/share-link-metadata`,
    data: {description},
  });
}
